(function () {
  'use strict';

  var SECTION_KEY = '17844146307f74c935';
  var GOLD = '#B28E39';
  var PRODUCT_CLASS = /product[-_ ]?(title|name|link|badge|label)|(?:title|name|link|badge)[-_ ]?product/i;
  var REVIEW_CLASS = /review[-_ ]?(text|content|body|message)|comment[-_ ]?(text|content|body)|reviewtext|reviewcontent|reviewbody|description/i;

  function mobile() {
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }

  function setImp(el, prop, val) {
    if (el && el.style) el.style.setProperty(prop, val, 'important');
  }

  function text(el) {
    return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function cls(el) {
    if (!el) return '';
    if (typeof el.className === 'string') return el.className;
    return el.getAttribute ? (el.getAttribute('class') || '') : '';
  }

  function roots(root) {
    var out = [root], q = [root];
    while (q.length) {
      var r = q.shift();
      if (!r || !r.querySelectorAll) continue;
      r.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot && out.indexOf(el.shadowRoot) === -1) {
          out.push(el.shadowRoot);
          q.push(el.shadowRoot);
        }
      });
    }
    return out;
  }

  function ancestorMatch(el, re, max) {
    var cur = el, d = 0;
    while (cur && d <= max) {
      if (re.test(cls(cur))) return true;
      cur = cur.parentElement;
      d++;
    }
    return false;
  }

  function metadata(el, t) {
    var l = t.toLowerCase();
    if (!t || l === 'etsy' || l === 'verified' || l === 'recent' || l === 'filter images') return true;
    if (/\bverified\b/.test(l)) return true;
    if (/^(\d+|a|an)\s+(second|minute|hour|day|week|month|year)s?\s+ago$/.test(l)) return true;
    if (/^(today|yesterday)$/.test(l)) return true;
    if (ancestorMatch(el, /(reviewer|author|customer|user)[-_ ]?name|name[-_ ]?(reviewer|author|customer|user)/i, 4)) return true;
    if (ancestorMatch(el, /verified|platform|date|time|source|rating/i, 3)) return true;
    return false;
  }

  function plainBg(bg) {
    return !bg || bg === 'transparent' || bg === 'rgba(0, 0, 0, 0)' || bg === 'rgba(0,0,0,0)' || bg === 'rgb(255, 255, 255)' || bg === 'rgba(255, 255, 255, 1)';
  }

  function productBar(el) {
    if (!el || !el.getBoundingClientRect || !window.getComputedStyle) return false;
    if (el.querySelector && el.querySelector('img')) return false;
    var t = text(el), l = t.toLowerCase();
    if (t.length < 8 || t.length > 130) return false;
    if (/^(read more|read less|load more|filter images|recent|verified|etsy|you may also like)$/.test(l) || /\bago$/.test(l)) return false;
    var rect = el.getBoundingClientRect();
    if (!rect.width || !rect.height || rect.width < document.documentElement.clientWidth * 0.55 || rect.height < 28 || rect.height > 100) return false;
    var st = window.getComputedStyle(el);
    return !plainBg(st.backgroundColor) && parseFloat(st.borderRadius || '0') >= 5;
  }

  function productRelated(el) {
    var cur = el, d = 0;
    while (cur && d <= 4) {
      if (cur.matches && cur.matches('a[href*="/products/"]')) return true;
      if (PRODUCT_CLASS.test(cls(cur)) || productBar(cur)) return true;
      cur = cur.parentElement;
      d++;
    }
    return false;
  }

  function goldBar(el) {
    setImp(el, 'background-color', GOLD);
    setImp(el, 'border-color', GOLD);
    setImp(el, 'color', '#111');
    if (el.querySelectorAll) el.querySelectorAll('*').forEach(function (c) {
      setImp(c, 'background-color', 'transparent');
      setImp(c, 'color', '#111');
    });
  }

  function productAnchorForBar(el) {
    if (!el) return null;
    if (el.matches && el.matches('a[href*="/products/"]')) return el;

    var inside = el.querySelector && el.querySelector('a[href*="/products/"]');
    if (inside) return inside;

    var parent = el.parentElement;
    if (parent && parent.querySelectorAll) {
      var parentLinks = parent.querySelectorAll('a[href*="/products/"]');
      if (parentLinks.length === 1) return parentLinks[0];
    }

    var grand = parent && parent.parentElement;
    if (grand && grand.querySelectorAll && /(review|product|card)/i.test(cls(grand))) {
      var grandLinks = grand.querySelectorAll('a[href*="/products/"]');
      if (grandLinks.length === 1) return grandLinks[0];
    }

    return null;
  }

  function makeProductBarClickable(el) {
    var link = productAnchorForBar(el);
    if (!link) return;

    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener');
    setImp(el, 'cursor', 'pointer');

    if (el === link || el.getAttribute('data-cc-product-click') === '1') return;

    el.setAttribute('data-cc-product-click', '1');
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    if (!el.hasAttribute('role')) el.setAttribute('role', 'link');

    el.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('a[href*="/products/"]')) return;
      link.click();
    });

    el.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        link.click();
      }
    });
  }

  function styleProductBars(root) {
    root.querySelectorAll('a[href*="/products/"], [class*="product"], [class*="Product"], div, span').forEach(function (el) {
      if (!productBar(el)) return;
      goldBar(el);
      makeProductBarClickable(el);
    });
  }

  function styleQuotes(root) {
    root.querySelectorAll('[class*="quote"] svg, [class*="Quote"] svg, [class*="quotation"] svg, [class*="Quotation"] svg').forEach(function (svg) {
      setImp(svg, 'width', '24px');
      setImp(svg, 'height', '24px');
      setImp(svg, 'max-width', '24px');
      setImp(svg, 'max-height', '24px');
      setImp(svg, 'color', GOLD);
      setImp(svg, 'fill', GOLD);
      setImp(svg, 'stroke', GOLD);
      svg.querySelectorAll('path, g, use, polygon, polyline, rect, circle, ellipse').forEach(function (p) {
        setImp(p, 'color', GOLD);
        setImp(p, 'fill', GOLD);
        setImp(p, 'stroke', GOLD);
      });
    });
  }

  function styleReviewText(root) {
    root.querySelectorAll('p, div, span').forEach(function (el) {
      if (el.closest && el.closest('button, h1, h2, h3, h4, h5, h6, select, label')) return;
      var t = text(el);
      if (!t || t.length > 1600 || metadata(el, t) || productRelated(el)) return;
      var hinted = ancestorMatch(el, REVIEW_CLASS, 4);
      if (t.length < 18 && !hinted) return;
      var childText = false;
      Array.prototype.forEach.call(el.children || [], function (c) { if (text(c).length > 20) childText = true; });
      if (childText) return;
      setImp(el, 'font-size', '14px');
      setImp(el, 'line-height', '1.14');
      setImp(el, 'color', '#111');
      setImp(el, 'margin-top', '0');
      setImp(el, 'margin-bottom', '0');
      setImp(el, 'padding-top', '0');
      setImp(el, 'padding-bottom', '0');
      el.querySelectorAll('span, a').forEach(function (c) {
        var ct = text(c);
        if (!ct || metadata(c, ct) || productRelated(c)) return;
        setImp(c, 'font-size', '14px');
        setImp(c, 'line-height', '1.14');
        setImp(c, 'color', '#111');
      });
    });

    root.querySelectorAll('a, button, span, div').forEach(function (el) {
      var l = text(el).toLowerCase();
      if (l !== 'read more' && l !== 'read less') return;
      setImp(el, 'font-size', '14px');
      setImp(el, 'line-height', '1.1');
      setImp(el, 'color', '#111');
    });
  }

  function styleNames(root) {
    root.querySelectorAll('[class*="name"], [class*="Name"]').forEach(function (el) {
      if (productRelated(el)) return;
      var t = text(el);
      if (!t || t.length > 40 || /verified|etsy|ago/i.test(t)) return;
      setImp(el, 'font-size', '18px');
      setImp(el, 'line-height', '1.2');
    });
  }

  function exactTextNode(root, value) {
    if (!root || !root.querySelectorAll) return null;
    var wanted = String(value || '').toLowerCase();
    var nodes = root.querySelectorAll('div, span, p, label, button, a');
    for (var i = 0; i < nodes.length; i++) {
      if (text(nodes[i]).toLowerCase() === wanted) return nodes[i];
    }
    return null;
  }

  function nearestCommonAncestor(a, b, maxDepth) {
    if (!a || !b) return null;
    var ancestors = [], cur = b, d = 0;
    while (cur && d <= maxDepth) {
      ancestors.push(cur);
      cur = cur.parentElement;
      d++;
    }
    cur = a;
    d = 0;
    while (cur && d <= maxDepth) {
      if (ancestors.indexOf(cur) !== -1) return cur;
      cur = cur.parentElement;
      d++;
    }
    return null;
  }

  function styleReviewControls(root) {
    if (!root || !root.querySelectorAll || !window.getComputedStyle) return;

    var filter = exactTextNode(root, 'filter images');
    var recent = exactTextNode(root, 'recent');
    if (!filter || !recent || !filter.getBoundingClientRect || !recent.getBoundingClientRect) return;

    var fr = filter.getBoundingClientRect();
    var rr = recent.getBoundingClientRect();
    if (!fr.width || !rr.width || Math.abs(fr.top - rr.top) > 45) return;

    var controlBottom = Math.max(fr.bottom, rr.bottom);
    var row = nearestCommonAncestor(filter, recent, 8);
    if (row && row.getBoundingClientRect) {
      var rowRect = row.getBoundingClientRect();
      if (rowRect.height > 0 && rowRect.height < 180) {
        setImp(row, 'margin-bottom', '-6px');
        setImp(row, 'padding-bottom', '0');
        setImp(row, 'min-height', '0');
      }
    }

    [filter, recent].forEach(function (el) {
      var p = el.parentElement;
      if (p && p !== row) {
        setImp(p, 'margin-top', '0');
        setImp(p, 'margin-bottom', '0');
        setImp(p, 'padding-top', '0');
        setImp(p, 'padding-bottom', '0');
      }
    });

    var best = null;
    root.querySelectorAll('button, [role="button"], div, span').forEach(function (el) {
      if (!el.querySelectorAll || !el.getBoundingClientRect) return;
      var svgCount = el.querySelectorAll('svg').length;
      if (svgCount < 5 || svgCount > 8) return;
      var label = text(el).toLowerCase();
      if (label.length > 40 || /verified|etsy|ago/.test(label)) return;
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) return;
      if (r.top < controlBottom - 10 || r.top > controlBottom + 180) return;
      if (r.height < 22 || r.height > 100) return;
      if (r.width < 90 || r.width > document.documentElement.clientWidth * 0.9) return;
      var distance = Math.max(0, r.top - controlBottom);
      if (!best || distance < best.distance || (distance === best.distance && r.height < best.rect.height)) {
        best = { el: el, rect: r, distance: distance };
      }
    });

    if (!best) return;

    var star = best.el;
    setImp(star, 'margin-top', '0');
    setImp(star, 'margin-bottom', '0');
    setImp(star, 'padding-top', '0');
    setImp(star, 'padding-bottom', '0');

    var starParent = star.parentElement;
    if (starParent) {
      setImp(starParent, 'margin-top', '-7px');
      setImp(starParent, 'margin-bottom', '-7px');
      setImp(starParent, 'padding-top', '0');
      setImp(starParent, 'padding-bottom', '0');
    }

    var stack = nearestCommonAncestor(filter, star, 8);
    if (stack && stack.getBoundingClientRect) {
      var stackRect = stack.getBoundingClientRect();
      var stackStyle = window.getComputedStyle(stack);
      if (stackRect.height > 0 && stackRect.height < 280 && /flex|grid/.test(stackStyle.display || '')) {
        setImp(stack, 'row-gap', '8px');
      }
    }

    var starRect = star.getBoundingClientRect();
    var cardBest = null;
    root.querySelectorAll('article, li, div').forEach(function (el) {
      if (!el.getBoundingClientRect) return;
      var content = text(el).toLowerCase();
      if (content.indexOf('verified') === -1 && content.indexOf('etsy') === -1) return;
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) return;
      if (r.top < starRect.bottom - 5 || r.top > starRect.bottom + 250) return;
      if (r.width < document.documentElement.clientWidth * 0.72 || r.height < 130 || r.height > 900) return;
      var st = window.getComputedStyle(el);
      var radius = parseFloat(st.borderRadius || '0');
      var border = Math.max(parseFloat(st.borderTopWidth || '0'), parseFloat(st.borderRightWidth || '0'), parseFloat(st.borderBottomWidth || '0'), parseFloat(st.borderLeftWidth || '0'));
      var shadow = st.boxShadow && st.boxShadow !== 'none';
      if (radius < 8 || (!border && !shadow)) return;
      if (!cardBest || r.top < cardBest.rect.top || (Math.abs(r.top - cardBest.rect.top) < 3 && r.height < cardBest.rect.height)) {
        cardBest = { el: el, rect: r };
      }
    });

    if (cardBest) {
      setImp(cardBest.el, 'margin-top', '-8px');
    }
  }

  function styleLoadMore(root) {
    root.querySelectorAll('button, a, [role="button"], div, span').forEach(function (el) {
      if (text(el).toLowerCase() !== 'load more') return;
      setImp(el, 'font-size', '16px');
      setImp(el, 'line-height', '1.15');
      setImp(el, 'min-width', '0');
      setImp(el, 'width', 'auto');
      setImp(el, 'min-height', '34px');
      setImp(el, 'height', 'auto');
      setImp(el, 'padding', '6px 14px');
      setImp(el, 'margin-top', '0');
      setImp(el, 'margin-bottom', '0');
      var p = el.parentElement;
      if (p) {
        setImp(p, 'margin-top', '-9px');
        setImp(p, 'margin-bottom', '0');
        setImp(p, 'padding-top', '0');
        setImp(p, 'padding-bottom', '0');
      }
    });
  }

  function styleRecommendations(root) {
    root.querySelectorAll('h1, h2, h3, h4, h5, h6, p, div, span').forEach(function (el) {
      if (text(el).toLowerCase() !== 'you may also like') return;
      setImp(el, 'font-size', '16px');
      setImp(el, 'line-height', '1.1');
      setImp(el, 'margin-top', '0');
      setImp(el, 'margin-bottom', '10px');
    });
  }

  function apply() {
    if (!mobile()) return;
    var section = document.querySelector('[id*="' + SECTION_KEY + '"]');
    if (section) {
      setImp(section, 'margin-bottom', '0');
      setImp(section, 'padding-bottom', '0');
      roots(section).forEach(function (r) {
        styleProductBars(r);
        styleReviewText(r);
        styleQuotes(r);
        styleNames(r);
        styleReviewControls(r);
        styleLoadMore(r);
      });
    }
    roots(document).forEach(function (r) {
      styleReviewControls(r);
      styleLoadMore(r);
      styleRecommendations(r);
    });
  }

  function start() {
    apply();
    [200, 600, 1200, 2200, 4000].forEach(function (d) { window.setTimeout(apply, d); });
    if (document.body && window.MutationObserver) {
      new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

(function () {
  'use strict';

  var SECTION_KEY = '17844146307f74c935';
  var reviewLimitExpanded = false;

  function mobile() {
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }

  function text(el) {
    return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function setImp(el, prop, val) {
    if (el && el.style) el.style.setProperty(prop, val, 'important');
  }

  function roots(root) {
    var out = [root], queue = [root];
    while (queue.length) {
      var current = queue.shift();
      if (!current || !current.querySelectorAll) continue;
      current.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot && out.indexOf(el.shadowRoot) === -1) {
          out.push(el.shadowRoot);
          queue.push(el.shadowRoot);
        }
      });
    }
    return out;
  }

  function reviewCardLike(el) {
    if (!el || !el.getBoundingClientRect || !window.getComputedStyle) return false;
    var rect = el.getBoundingClientRect();
    if (!rect.width || !rect.height) return false;
    if (rect.width < document.documentElement.clientWidth * 0.72 || rect.height < 130 || rect.height > 900) return false;
    var style = window.getComputedStyle(el);
    var radius = parseFloat(style.borderRadius || '0');
    var border = Math.max(
      parseFloat(style.borderTopWidth || '0'),
      parseFloat(style.borderRightWidth || '0'),
      parseFloat(style.borderBottomWidth || '0'),
      parseFloat(style.borderLeftWidth || '0')
    );
    var shadow = style.boxShadow && style.boxShadow !== 'none';
    return radius >= 8 && (border > 0 || shadow);
  }

  function closestReviewCard(marker) {
    var current = marker;
    for (var depth = 0; current && depth <= 8; depth++) {
      if (reviewCardLike(current)) return current;
      current = current.parentElement;
    }
    return null;
  }

  function addUnique(list, item) {
    if (item && list.indexOf(item) === -1) list.push(item);
  }

  function findReviewCards(root) {
    if (!root || !root.querySelectorAll) return [];
    var cards = [];

    root.querySelectorAll('[data-cc-review-hidden-by-limit="1"]').forEach(function (card) {
      addUnique(cards, card);
    });

    root.querySelectorAll('div, span, p, a').forEach(function (marker) {
      var label = text(marker).toLowerCase();
      if (!label || label.length > 120) return;
      if (label.indexOf('verified') === -1 && label !== 'etsy' && label.indexOf('etsy') === -1) return;
      addUnique(cards, closestReviewCard(marker));
    });

    root.querySelectorAll('article, li, div').forEach(function (candidate) {
      if (!reviewCardLike(candidate)) return;
      var content = text(candidate).toLowerCase();
      if (content.indexOf('verified') === -1 && content.indexOf('etsy') === -1) return;
      addUnique(cards, candidate);
    });

    cards.sort(function (a, b) {
      var ai = parseInt(a.getAttribute('data-cc-review-limit-order'), 10);
      var bi = parseInt(b.getAttribute('data-cc-review-limit-order'), 10);
      if (!isNaN(ai) && !isNaN(bi)) return ai - bi;

      var ar = a.getBoundingClientRect ? a.getBoundingClientRect() : { top: 0, left: 0 };
      var br = b.getBoundingClientRect ? b.getBoundingClientRect() : { top: 0, left: 0 };
      if (Math.abs(ar.top - br.top) > 2) return ar.top - br.top;
      if (Math.abs(ar.left - br.left) > 2) return ar.left - br.left;
      if (a.compareDocumentPosition && (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING)) return -1;
      if (b.compareDocumentPosition && (b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_FOLLOWING)) return 1;
      return 0;
    });

    cards.forEach(function (card, index) {
      if (!card.hasAttribute('data-cc-review-limit-order')) {
        card.setAttribute('data-cc-review-limit-order', String(index));
      }
    });

    return cards;
  }

  function hideReviewCard(card) {
    if (!card || !card.style) return;
    if (!card.hasAttribute('data-cc-review-prev-display')) {
      card.setAttribute('data-cc-review-prev-display', card.style.getPropertyValue('display') || '');
      card.setAttribute('data-cc-review-prev-display-priority', card.style.getPropertyPriority('display') || '');
    }
    card.setAttribute('data-cc-review-hidden-by-limit', '1');
    card.style.setProperty('display', 'none', 'important');
  }

  function showReviewCard(card) {
    if (!card || !card.style) return;
    if (card.getAttribute('data-cc-review-hidden-by-limit') !== '1') return;

    var previous = card.getAttribute('data-cc-review-prev-display') || '';
    var priority = card.getAttribute('data-cc-review-prev-display-priority') || '';
    if (previous) card.style.setProperty('display', previous, priority);
    else card.style.removeProperty('display');

    card.removeAttribute('data-cc-review-hidden-by-limit');
    card.removeAttribute('data-cc-review-prev-display');
    card.removeAttribute('data-cc-review-prev-display-priority');
  }

  function revealHiddenReviews() {
    roots(document).forEach(function (root) {
      if (!root.querySelectorAll) return;
      root.querySelectorAll('[data-cc-review-hidden-by-limit="1"]').forEach(showReviewCard);
    });
  }

  function bindLoadMore(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('button, a, [role="button"]').forEach(function (el) {
      if (text(el).toLowerCase() !== 'load more') return;
      if (el.getAttribute('data-cc-review-limit-bound') === '1') return;
      el.setAttribute('data-cc-review-limit-bound', '1');
      el.addEventListener('click', function () {
        reviewLimitExpanded = true;
        revealHiddenReviews();
        window.setTimeout(applyLimit, 0);
        window.setTimeout(applyLimit, 250);
        window.setTimeout(applyLimit, 700);
      });
    });
  }

  function applyLimit() {
    if (!mobile()) return;

    var section = document.querySelector('[id*="' + SECTION_KEY + '"]');
    var allCards = [];

    if (section) {
      roots(section).forEach(function (root) {
        bindLoadMore(root);
        findReviewCards(root).forEach(function (card) {
          addUnique(allCards, card);
        });
      });
    }

    allCards.sort(function (a, b) {
      var ai = parseInt(a.getAttribute('data-cc-review-limit-order'), 10);
      var bi = parseInt(b.getAttribute('data-cc-review-limit-order'), 10);
      if (!isNaN(ai) && !isNaN(bi) && ai !== bi) return ai - bi;
      var ar = a.getBoundingClientRect ? a.getBoundingClientRect() : { top: 0, left: 0 };
      var br = b.getBoundingClientRect ? b.getBoundingClientRect() : { top: 0, left: 0 };
      if (Math.abs(ar.top - br.top) > 2) return ar.top - br.top;
      return ar.left - br.left;
    });

    allCards.forEach(function (card, index) {
      if (reviewLimitExpanded || index < 3) showReviewCard(card);
      else hideReviewCard(card);
    });

    var description = document.querySelector('[data-cc-product-description]');
    if (description) {
      setImp(description, 'margin-bottom', allCards.length ? '0px' : '24px');
    }
  }

  function start() {
    applyLimit();
    [250, 700, 1400, 2600, 4500].forEach(function (delay) {
      window.setTimeout(applyLimit, delay);
    });
    if (document.body && window.MutationObserver) {
      new MutationObserver(applyLimit).observe(document.body, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();


/* cc-desktop-rating-count-minus-2px-2026-10-18 */
(function () {
  'use strict';
  var resized = new WeakSet();
  var countText = /^\(\s*\d[\d,.]*\s+reviews?\s*\)$/i;

  function normalText(el) {
    return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll('span, a, small, p, div').forEach(function (el) {
      if (resized.has(el) || !countText.test(normalText(el))) return;
      var childWithCount = Array.prototype.some.call(el.children, function (child) {
        return countText.test(normalText(child));
      });
      if (childWithCount) return;
      var size = parseFloat(window.getComputedStyle(el).fontSize);
      if (!Number.isFinite(size) || size <= 2) return;
      el.style.setProperty('font-size', (size - 2) + 'px', 'important');
      resized.add(el);
    });
    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) scan(el.shadowRoot);
    });
  }

  function apply() {
    if (!window.matchMedia || !window.matchMedia('(min-width: 768px)').matches) return;
    var info = document.querySelector('.product-description-main-wrapper .product-info-wrapper');
    if (info) scan(info);
  }

  function start() {
    apply();
    [250, 700, 1500, 3000, 5000].forEach(function (delay) {
      window.setTimeout(apply, delay);
    });
    var info = document.querySelector('.product-description-main-wrapper .product-info-wrapper');
    if (info && window.MutationObserver) {
      new MutationObserver(apply).observe(info, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
